import React from 'react'
import axios from 'axios'
import { Spin, Alert, message, Table, Popconfirm, Button } from 'antd'


import apiPath from 'apiPath'
import moment from 'components/momentWithZone'
import stickyError from 'components/stickyError'
import ProgramCardList from '../ProgramCardList'
import loadFieldPrograms from '../loadFieldPrograms2'
import parseJSON from '../parseJSON'

export default class Registered extends React.Component {
	state = {
		itemMap: {},
		loading: false,
		loadProgress: 0,
		programs: [],
		chargeTotal: null,
		creditTotal: null,
		ports: [],
		allClasses: [],
		programsLoaded: false
		// cancel: 'test',
	}

	printScreen = () => {
		var printContent = document.getElementById('registered-print').outerHTML;
		printContent += "<style>@page{size: landscape;}body{font-family:'Helvetica Neue For Number', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size:12px!important;}td:nth-of-type(5),th:nth-of-type(5){display:none!important}</style>";
		var w = window.open();
		w.document.write(printContent);
		w.document.title = 'Semester At Sea';
		w.print();


		// w.close();
	}

	getItemMap = () => {
		axios
			.get(apiPath + '/fieldprograms')
			.then((result) => {
				let itemMap = {}
				result.data.map((item) => {
					return (itemMap[item.ItemId] = item.Code)
				})
				this.setState({ itemMap: itemMap })
			})
			.catch(this.props.handleAxiosLoadError)
	}

	getBalance = (props) => {
		if (props.bookingLoaded) {
			this.setState({
				chargeTotal: props.chargeTotal,
				creditTotal: props.creditTotal,
			})
		}
	}

	getFieldPrograms = () => {
		if (
			!sessionStorage.fieldProgramsUpdated ||
			!sessionStorage.fieldProgramsForVoyage ||
			moment(sessionStorage.fieldProgramsUpdated, 'X')
				.add(1, 'hours')
				.isBefore(moment()) ||
			sessionStorage.fieldProgramsForVoyage !==
			(this.props.booking.EventId || this.props.booking.TripCode)
		) {
			this.setState({ loading: true })

			loadFieldPrograms(this.props.booking.EventId)
				.catch((error) => {
					console.error(error)
					stickyError(error.message, 0, true)
				})
				.then(() => {
					this.setState({
						loading: false,
						programs: parseJSON(sessionStorage.fieldPrograms, []),
						programsLoaded: true,
					})
				})
		} else {
			this.setState({
				programs: parseJSON(sessionStorage.fieldPrograms, []),
				programsLoaded: true
			})
		}
	}

	getFieldClasses = () => {
		if (localStorage.fieldClasses) {
			this.setState({
				allClasses: parseJSON(localStorage.fieldClasses, []),
			})
		} else {
			window.setTimeout(this.getFieldClasses, 1000)
		}
	}



	cancelText = (program) => {
		var today = new Date();
		var portArrival = new Date(program.PortArrivalTime);
		var paidPrice = parseFloat(program.Price)
		var now = moment().format('YYYY-MM-DD');

		var dateDiff = moment(portArrival).diff(now, 'days');

		let fieldPrograms = this.props.bookedItems.filter(
			(item) => item.StoreId === '40'
		)


		let theProgram = fieldPrograms.filter(
			(item) => program.Code === this.state.itemMap[item.ItemId]
		)

		if (theProgram.length < 1) {
			return <div><h2>This is unable to be cancelled</h2></div>;
		}

		var getPricePaid = this.props.bookedItems.find(bk => bk.SaleId === theProgram[0].SaleId).Amount;
		//Koty asked for removal of over 90 day fee
		// if(dateDiff >= 90){
		// 	var fee = 0.00;
		// 	var percent = '0%';
		// }
		// else 
		if (dateDiff >= 45) {
			var fee = parseFloat(getPricePaid) / 2;
			var percent = '50%';
		} else {
			var fee = parseFloat(getPricePaid);
			var percent = '100%';
		}



		if (this.props.sectionIsEnabled && this.props.sectionIsEnabled(this.props, 'field/cancel-fee-disabled')) {
			var fee = 0.00;
			var percent = '0%';
		}

		const dateFormatted = new Intl.DateTimeFormat("en-US", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit"
		}).format(portArrival);

		return <div><h2>Are you sure?</h2><p>Cancelling your Field Program now will result in a {percent} cancellation fee of ${fee.toFixed(2)} per the Field Program Cancellation policy. Would you like to proceed?</p></div>;
		// return <div><p>You are cancelling the Field Program: {program.Title}. Per <a href='https://www.semesteratsea.org/financial-aid/payments-and-cancellations/#:~:text=Cancel%20over%2090%20days%20prior,of%20program%20fee%20and%20deposit*' target='_blank'>Semester at Sea Policy</a> this will incur a fee of ${fee.toFixed(2)}</p></div>;

	}

	//this will get sale ID of program that is being clicked to "remove"
	removeProgram = (program) => {

		let cancelFee = 'enabled';
		if (this.props.sectionIsEnabled && this.props.sectionIsEnabled(this.props, 'field/cancel-fee-disabled')) {
			cancelFee = 'disabled';
		}

		let fieldPrograms = this.props.bookedItems.filter(
			(item) => item.StoreId === '40'
		)
		let theProgram = fieldPrograms.filter(
			(item) => program.Code === this.state.itemMap[item.ItemId]
		)

		let saleId = theProgram[0].SaleId

		// cancel = this.cancelText(program);
		// this.setState({cancel: this.cancelText(program)})

		axios
			.delete(apiPath + '/item/' + saleId + '/' + cancelFee, { withCredentials: true })
			.then((result) => {
				this.props.refreshBooking()
				message.success(
					'Program successfully cancelled. Your Field Program balance has been adjusted accordingly and can be referenced here: "Payments and Financial Aid" tab --> "Field Payment Status.'
				)
			})
			.catch((error) => {
				stickyError(error.message)
			})
	}

	getPorts = async () => {
		if (!this.props.booking.EventId) return

		try {
			const response = await fetch(
				`${apiPath}/voyages/${this.props.booking.EventId}/ports`
			)

			if (!response.ok) {
				throw new Error(response.statusText)
			}

			const ports = await response.json()

			this.setState({ ports })
		} catch (error) {
			console.error(error)
		}
	}

	getPorts2 = async () => {
		if (!this.props.booking.EventId) return

		try {
			const response = await fetch(
				`/api/voyages/${this.props.booking.EventId}/ports`
			)

			if (!response.ok) {
				throw new Error(response.statusText)
			}

			const ports = await response.json()
			const portOrder = ports.map((port) => port.portCode)

			this.setState({ ports, portOrder })
		} catch (error) {
			console.error(error)
		}
	}

	componentDidMount() {
		if (window.location.href.indexOf('clearCart') !== -1) {
			localStorage.removeItem('fieldProgramCart')
		}
		this.getPorts2()
		this.getItemMap()
		this.getFieldPrograms()
		this.getFieldClasses()
		this.getBalance(this.props)
		this.props.refreshBooking()
	}

	componentWillReceiveProps(nextProps) {
		this.getBalance(nextProps)
	}


	render() {
		const disabled =
			this.props.variant !== 'admin' &&
			!this.props.sectionIsEnabled(this.props, 'field/registered')
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(
				this.props,
				'field/registered'
			)
			if (redirect) return redirect
		}

		let bookedItems = this.props.bookedItems
		const fieldClasses = bookedItems.filter(
			(item) =>
				item.StoreId === '33' &&
				item.ItemId !== '92' &&
				item.ItemId !== '93'
		)
		const fieldPrograms = bookedItems.filter(
			(item) => item.StoreId === '40' && item.ItemId !== '2760' && item.ItemId !== '2757'
		) // && this.state.itemMap[item.ItemId]);

		const programDta = fieldPrograms.map((item) =>
			this.state.programs.find(
				(program) =>
					program.Code === this.state.itemMap[item.ItemId]
			)
		);

		const classDta = fieldClasses
			.map((item) =>
				this.state.allClasses.find(
					(fclass) =>
						fclass.ItemId === item.ItemId
				)
			);

		const allData = bookedItems.filter((item) => (item.StoreId === '40' || item.StoreId === '33')
			&& item.ItemId !== '92' && item.ItemId !== '93' && item.ItemId !== '2760' && item.ItemId !== '2757').map((item) =>
				this.state.programs.find(
					(program) =>
						program.Code === this.state.itemMap[item.ItemId]
				) || this.state.allClasses.find(
					(fclass) =>
						fclass.ItemId === item.ItemId
				)
			).sort((a, b) => {
				let dateA;
				let dateB
				if (a && a.hasOwnProperty('BegDate')) {
					dateA = new Date(a.BegDate).getTime();
				} else if (a && a.hasOwnProperty('StartDateTime')) {
					dateA = new Date(a.StartDateTime).getTime();
				} else {
					console.error('a doesnt exist or has an issue');
				}
				if (b && b.hasOwnProperty('BegDate')) {
					dateB = new Date(b.BegDate).getTime();
				} else if (b && b.hasOwnProperty('StartDateTime')) {
					dateB = new Date(b.StartDateTime).getTime();
				} else {
					console.error('b doesnt exist or has an issue');
				}
				return dateA - dateB;
			});

		let { chargeTotal, creditTotal } = this.state
		let amount = this.state.amount || chargeTotal - creditTotal
		if (amount > chargeTotal - creditTotal)
			amount = chargeTotal - creditTotal
		let i = 0
		return (
			<div>
				{this.state.error && (
					<Alert type='error' message='Something went wrong' />
				)}

				{/* {(this.props.GSCneeded || this.props.GSCused) && ( */}
				{/* {(fieldClasses && fieldClasses.length > 0) && (
					<div style={{ marginBottom: '16pt' }}>
						<h3>Field Classes:</h3>
						{fieldClasses.length ? (
							<ul
								style={{
									listStyle: 'disc',
									marginLeft: '24pt',
								}}
							>
								{fieldClasses
									.map((item) =>
										this.state.allClasses.find(
											(fclass) =>
												fclass.ItemId === item.ItemId
										)
									)
									.map((item) => {
										if (!item) return null
										const port = this.state.ports.find(
											(port) =>
												port.portCode ==
												item.BegLocation
										)
										if (!item.BegDate)
											return (
												<li key={item.ItemId}>
													{item.Name}
												</li>
											)
										return (
											<li key={item.ItemId}>
												<strong>{item.Code}</strong>{' '}
												{item.Name} --{' '}
												{moment(item.BegDate).format(
													'MMMM D'
												)}
												{port && `, ${port.country}`}
											</li>
										)
									})}
							</ul>
						) : (
							<p style={{ marginLeft: '24pt' }}>None</p>
						)}
					</div>
				)} */}

				{(this.state.loading || !this.props.bookingLoaded) &&
					!this.state.error && (
						<div style={{ textAlign: 'center' }}>
							<Spin />
						</div>
					)}
				{this.props.bookingLoaded &&
					!this.props.bookingError &&
					!fieldPrograms.length &&
					!this.state.loading &&
					Object.keys(this.state.itemMap).length > 0 && (
						<Alert
							showIcon
							type='warning'
							message='No Field Programs'
							description="You haven't registered for any Field Programs"
						/>
					)}
				{chargeTotal > creditTotal && (
					<Alert
						showIcon
						type='error'
						message='Payment Required'
						description={
							<span>
								You have an outstanding balance on your account.
								You have <strong>seven days</strong> from the
								time of registration to complete payment. After
								this, you will receive one warning email from
								Semester at Sea before being canceled from the
								program (all standard{' '}
								<a href='https://2xj3ep1sacqvsluiw1w0g438-wpengine.netdna-ssl.com/wp-content/uploads/%E2%80%9D/SP18ImportantDatesDeadlinesandCancelPolicy.pdf'>
									cancellation penalties
								</a>{' '}
								apply.)
								<br />
								<br />
								If you believe you should have a financial aid
								credit that is not appearing, please email{' '}
								<a href='mailto:financialaid@semesteratsea.org'>
									financialaid@semesteratsea.org
								</a>
								.
								<br />
								<br />
								To cancel or change a program, contact{' '}
								<a href='mailto:Field@isevoyages.org'>
									Field@isevoyages.org
								</a>
								. If you have paid for these programs but are
								still seeing this message, please notify us.
							</span>
						}
					/>
				)}
				{/* <ProgramCardList
					programs={fieldPrograms.map((item) =>
						this.state.programs.find(
							(program) =>
								program.Code === this.state.itemMap[item.ItemId]
						)
					)}
					booking={this.props.booking}
					shouldShowCartButtons={false}
					cardProps={{
						loading: this.state.loading,
						showPrice: false,
						showBanners: false,
						showSpotsLeft: false,
						onRemoveProgram: this.removeProgram,
						showRemoveButton:
							!disabled && this.props.variant !== 'admin',
						getCancelText: this.cancelText
					}}
				/> */}
				{!this.state.loading && this.props.bookingLoaded && this.state.programsLoaded &&
					<div>
						<Button onClick={this.printScreen} style={{ 'marginBottom': '18px', 'float': 'right' }}>Print</Button>
						<div style={{ 'clear': 'both' }} />
						<div id='registered-print'>
							<h3>Registered Programs:</h3>

							<br />
							<style dangerouslySetInnerHTML={{
								__html: `.ant-table-wrapper {
  zoom: 1;
}
.ant-table-wrapper:before,
.ant-table-wrapper:after {
  content: " ";
  display: table;
}
.ant-table-wrapper:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-table {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  position: relative;
  border-radius: 4px 4px 0 0;
}
.ant-table-body {
  transition: opacity 0.3s ease;
}
.ant-table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}
.ant-table-thead > tr > th {
  background: #f7f7f7;
  font-weight: 500;
  transition: background .3s ease;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
}
.ant-table-thead > tr > th[colspan] {
  text-align: center;
}
.ant-table-thead > tr > th .anticon-filter,
.ant-table-thead > tr > th .ant-table-filter-icon {
  position: relative;
  margin-left: 4px;
  font-size: 12px;
  cursor: pointer;
  color: #999;
  transition: all .3s;
  width: 14px;
}
.ant-table-thead > tr > th .anticon-filter:hover,
.ant-table-thead > tr > th .ant-table-filter-icon:hover {
  color: rgba(0, 0, 0, 0.65);
}
.ant-table-thead > tr > th .anticon-filter:after,
.ant-table-thead > tr > th .ant-table-filter-icon:after {
  content: '';
  position: absolute;
  width: 14px;
  height: 50px;
  left: 0;
  top: -19px;
}
.ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {
  color: #108ee9;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid #e9e9e9;
  transition: all .3s;
}
.ant-table-thead > tr,
.ant-table-tbody > tr {
  transition: all .3s;
}
.ant-table-thead > tr.ant-table-row-hover > td,
.ant-table-tbody > tr.ant-table-row-hover > td,
.ant-table-thead > tr:hover > td,
.ant-table-tbody > tr:hover > td {
  background: #ecf6fd;
}
.ant-table-thead > tr:hover {
  background: none;
}
.ant-table-footer {
  padding: 16px 8px;
  background: #f7f7f7;
  border-radius: 0 0 4px 4px;
  position: relative;
}
.ant-table-footer:before {
  content: '';
  height: 1px;
  background: #f7f7f7;
  position: absolute;
  top: -1px;
  width: 100%;
  left: 0;
}
.ant-table.ant-table-bordered .ant-table-footer {
  border: 1px solid #e9e9e9;
}
.ant-table-title {
  padding: 16px 0;
  position: relative;
  top: 1px;
  border-radius: 4px 4px 0 0;
}
.ant-table.ant-table-bordered .ant-table-title {
  border: 1px solid #e9e9e9;
  padding-left: 8px;
  padding-right: 8px;
}
.ant-table-title + .ant-table-content {
  position: relative;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}
.ant-table-bordered .ant-table-title + .ant-table-content,
.ant-table-bordered .ant-table-title + .ant-table-content table {
  border-radius: 0;
}
.ant-table-without-column-header .ant-table-title + .ant-table-content,
.ant-table-without-column-header table {
  border-radius: 0;
}
.ant-table-tbody > tr.ant-table-row-selected {
  background: #fafafa;
}
.ant-table-thead > tr > th.ant-table-column-sort {
  background: #eee;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 16px 8px;
  word-break: break-all;
}
.ant-table-thead > tr > th.ant-table-selection-column-custom {
  padding-left: 16px;
  padding-right: 0;
}
.ant-table-thead > tr > th.ant-table-selection-column,
.ant-table-tbody > tr > td.ant-table-selection-column {
  text-align: center;
  min-width: 62px;
  width: 62px;
}
.ant-table-thead > tr > th.ant-table-selection-column .ant-radio-wrapper,
.ant-table-tbody > tr > td.ant-table-selection-column .ant-radio-wrapper {
  margin-right: 0;
}
.ant-table-expand-icon-th,
.ant-table-row-expand-icon-cell {
  text-align: center;
  min-width: 50px;
  width: 50px;
}
.ant-table-header {
  background: #f7f7f7;
  overflow: hidden;
}
.ant-table-header table {
  border-radius: 4px 4px 0 0;
}
.ant-table-loading {
  position: relative;
}
.ant-table-loading .ant-table-body {
  background: #fff;
  opacity: 0.5;
}
.ant-table-loading .ant-table-spin-holder {
  height: 20px;
  line-height: 20px;
  left: 50%;
  top: 50%;
  margin-left: -30px;
  position: absolute;
}
.ant-table-loading .ant-table-with-pagination {
  margin-top: -20px;
}
.ant-table-loading .ant-table-without-pagination {
  margin-top: 10px;
}
.ant-table-middle .ant-table-thead > tr > th,
.ant-table-middle .ant-table-tbody > tr > td {
  padding: 10px 8px;
}
.ant-table-middle .ant-table-title,
.ant-table-middle .ant-table-footer {
  padding: 10px 8px;
}
.ant-table-middle .ant-table-column-sorter-up:after {
  top: -13px;
  height: 13px;
}
.ant-table-middle .ant-table-column-sorter-down:after {
  bottom: -11px;
  height: 13px;
}
.ant-table-middle .ant-table-thead > tr > th .anticon-filter:after,
.ant-table-middle .ant-table-thead > tr > th .ant-table-filter-icon:after {
  height: 38px;
  top: -13px;
}
.ant-table-small {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}
.ant-table-small .ant-table-header > table,
.ant-table-small .ant-table-body > table {
  border: 0;
  padding: 0 8px;
}
.ant-table-small .ant-table-thead > tr > th {
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-small .ant-table-tbody > tr > td {
  padding: 6px 8px;
}
.ant-table-small .ant-table-title,
.ant-table-small .ant-table-footer,
.ant-table-small .ant-table-thead > tr > th {
  padding: 10px 8px;
}
.ant-table-small .ant-table-title {
  border-bottom: 1px solid #e9e9e9;
  top: 0;
}
.ant-table-small .ant-table-header {
  background: #fff;
}
.ant-table-small .ant-table-placeholder,
.ant-table-small .ant-table-row:last-child td {
  border-bottom: 0;
}
.ant-table-small .ant-table-column-sorter-up:after {
  top: -14px;
  height: 13px;
}
.ant-table-small .ant-table-column-sorter-down:after {
  bottom: -11px;
  height: 13px;
}
.ant-table-small .ant-table-thead > tr > th .anticon-filter:after,
.ant-table-small .ant-table-thead > tr > th .ant-table-filter-icon:after {
  height: 39px;
  top: -14px;
}
.ant-table-column-sorter {
  position: relative;
  margin-left: 4px;
  display: inline-block;
  width: 14px;
  vertical-align: middle;
  text-align: center;
}
.ant-table-column-sorter-up,
.ant-table-column-sorter-down {
  line-height: 4px;
  display: block;
  width: 14px;
  height: 6px;
  cursor: pointer;
}
.ant-table-column-sorter-up:hover .anticon,
.ant-table-column-sorter-down:hover .anticon {
  color: rgba(0, 0, 0, 0.65);
}
.ant-table-column-sorter-up.on .anticon-caret-up,
.ant-table-column-sorter-down.on .anticon-caret-up,
.ant-table-column-sorter-up.on .anticon-caret-down,
.ant-table-column-sorter-down.on .anticon-caret-down {
  color: #108ee9;
}
.ant-table-column-sorter-up:after,
.ant-table-column-sorter-down:after {
  position: absolute;
  content: '';
  height: 20px;
  width: 14px;
  left: 0;
}
.ant-table-column-sorter-up:after {
  top: -19px;
}
.ant-table-column-sorter-down:after {
  bottom: -17px;
}
.ant-table-column-sorter .anticon-caret-up,
.ant-table-column-sorter .anticon-caret-down {
  display: inline-block;
  font-size: 12px;
  font-size: 8px;
  -ms-transform: scale(0.66666667) rotate(0deg);
      transform: scale(0.66666667) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  line-height: 4px;
  height: 4px;
  color: #999;
  transition: all .3s;
}
:root .ant-table-column-sorter .anticon-caret-up,
:root .ant-table-column-sorter .anticon-caret-down {
  filter: none;
}
:root .ant-table-column-sorter .anticon-caret-up,
:root .ant-table-column-sorter .anticon-caret-down {
  font-size: 12px;
}
.ant-table-bordered .ant-table-header > table,
.ant-table-bordered .ant-table-body > table,
.ant-table-bordered .ant-table-fixed-left table,
.ant-table-bordered .ant-table-fixed-right table {
  border: 1px solid #e9e9e9;
  border-right: 0;
  border-bottom: 0;
}
.ant-table-bordered.ant-table-empty .ant-table-placeholder {
  border-left: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {
  border-bottom: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {
  border-top: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-placeholder {
  border: 0;
}
.ant-table-bordered .ant-table-thead > tr > th {
  border-bottom: 1px solid #e9e9e9;
}
.ant-table-bordered .ant-table-thead > tr > th,
.ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small {
  border-right: 0;
}
.ant-table-bordered.ant-table-small .ant-table-header > table,
.ant-table-bordered.ant-table-small .ant-table-body > table,
.ant-table-bordered.ant-table-small .ant-table-fixed-left table,
.ant-table-bordered.ant-table-small .ant-table-fixed-right table {
  border: 0;
  padding: 0;
}
.ant-table-bordered.ant-table-small .ant-table-title {
  border: 0;
  border-bottom: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small .ant-table-footer {
  border: 0;
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}
.ant-table-bordered.ant-table-small .ant-table-footer:before {
  display: none;
}
.ant-table-bordered.ant-table-small .ant-table-placeholder {
  border-left: 0;
  border-bottom: 0;
}
.ant-table-placeholder {
  position: relative;
  padding: 16px 8px;
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
  text-align: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.43);
  z-index: 1;
}
.ant-table-placeholder .anticon {
  margin-right: 4px;
}
.ant-table-pagination.ant-pagination {
  margin: 16px 0;
  float: right;
}
.ant-table-filter-dropdown {
  min-width: 96px;
  margin-left: -8px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-filter-dropdown .ant-dropdown-menu {
  border: 0;
  box-shadow: none;
  border-radius: 4px 4px 0 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-without-submenu {
  max-height: 400px;
  overflow-x: hidden;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {
  padding-right: 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-sub {
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title:after {
  color: #108ee9;
  font-weight: bold;
  text-shadow: 0 0 2px #d2eafb;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item {
  overflow: hidden;
}
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {
  border-radius: 0;
}
.ant-table-filter-dropdown-btns {
  overflow: hidden;
  padding: 7px 8px;
  border-top: 1px solid #e9e9e9;
}
.ant-table-filter-dropdown-link {
  color: #108ee9;
}
.ant-table-filter-dropdown-link:hover {
  color: #49a9ee;
}
.ant-table-filter-dropdown-link:active {
  color: #0e77ca;
}
.ant-table-filter-dropdown-link.confirm {
  float: left;
}
.ant-table-filter-dropdown-link.clear {
  float: right;
}
.ant-table-selection-select-all-custom {
  margin-right: 4px !important;
}
.ant-table-selection .anticon-down {
  color: #999;
  transition: all .3s;
}
.ant-table-selection-menu {
  min-width: 96px;
  margin-top: 5px;
  margin-left: -30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-table-selection-menu .ant-action-down {
  color: #999;
}
.ant-table-selection-down {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  line-height: 1;
}
.ant-table-selection-down:hover .anticon-down {
  color: #666;
}
.ant-table-row-expand-icon {
  cursor: pointer;
  display: inline-block;
  width: 17px;
  height: 17px;
  text-align: center;
  line-height: 14px;
  border: 1px solid #e9e9e9;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  background: #fff;
}
.ant-table-row-expanded:after {
  content: '-';
}
.ant-table-row-collapsed:after {
  content: '+';
}
.ant-table-row-spaced {
  visibility: hidden;
}
.ant-table-row-spaced:after {
  content: '.';
}
.ant-table-row[class*="ant-table-row-level-0"] .ant-table-selection-column > span {
  display: inline-block;
}
tr.ant-table-expanded-row,
tr.ant-table-expanded-row:hover {
  background: #fbfbfb;
}
.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 8px;
}
.ant-table-scroll {
  overflow: auto;
  overflow-x: hidden;
}
.ant-table-scroll table {
  width: auto;
  min-width: 100%;
}
.ant-table-body-inner {
  height: 100%;
}
.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  position: relative;
  background: #fff;
}
.ant-table-fixed-header .ant-table-body-inner {
  overflow: scroll;
}
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  overflow: scroll;
  padding-bottom: 20px;
  margin-bottom: -20px;
}
.ant-table-fixed-left,
.ant-table-fixed-right {
  position: absolute;
  top: 0;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  border-radius: 0;
}
.ant-table-fixed-left table,
.ant-table-fixed-right table {
  width: auto;
  background: #fff;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,
.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {
  border-radius: 0;
}
.ant-table-fixed-left {
  left: 0;
  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.2);
}
.ant-table-fixed-left .ant-table-header {
  overflow-y: hidden;
}
.ant-table-fixed-left .ant-table-body-inner {
  margin-right: -20px;
  padding-right: 20px;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {
  padding-right: 0;
}
.ant-table-fixed-left,
.ant-table-fixed-left table {
  border-radius: 4px 0 0 0;
}
.ant-table-fixed-right {
  right: 0;
  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.2);
}
.ant-table-fixed-right,
.ant-table-fixed-right table {
  border-radius: 0 4px 0 0;
}
.ant-table-fixed-right .ant-table-expanded-row {
  color: transparent;
  pointer-events: none;
}
.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {
  box-shadow: none;
}
.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {
  box-shadow: none;
}`}}></style>
							<div className='ant-table-wrapper printable' style={{ 'backgroundColor': 'white' }}>
								<div className='ant-table ant-table-small ant-table-bordered ant-table-scroll-position-left'>
									<div className='ant-table-body'>
										<table id='registered' className='printable'>
											<colgroup>
												<col className='start-col' />
												<col className='end-col' />
												<col className='code-col' />
												<col className='title-col' />
												<col className='cancel-col' />
											</colgroup>
											<thead className='ant-table-thead'>
												<tr>
													<th>
														Start Date
													</th>
													<th>
														End Date
													</th>
													<th>
														Program Code
													</th>
													<th>
														Title
													</th>
													<th>
														Cancel?
													</th>
												</tr>
											</thead>
											<tbody className='ant-table-tbody'>
												{allData.map((item) => {
													if (item) {
														const startDate = new Date(item.StartDateTime).getTime();
														let hideCancelButton = item.hasOwnProperty("GroupCode") && item.GroupCode == 'FIELDCLASS' || item.hasOwnProperty('EventId') && item.EventId === '56';
														if (!this.props.sectionIsEnabled(this.props, 'field/registered') || startDate < Date.now()) {
															hideCancelButton = true;
														}
														// console.log(item, (!this.props.sectionIsEnabled(this.props, 'field/registered') || startDate < Date.now()));
														return (
															<tr key={item.Code} className='ant-table-row  ant-table-row-level-0'>
																<td>{item.hasOwnProperty('BegDate') ? item.BegDate.replace('T', ' ').substring(0, item.BegDate.length - 3) : item.StartDateTime.replace('T', ' ').substring(0, item.StartDateTime.length - 3)}</td>
																<td>{item.hasOwnProperty('EndDate') ? item.EndDate.replace('T', ' ').substring(0, item.EndDate.length - 3) : item.EndDateTime.replace('T', ' ').substring(0, item.EndDateTime.length - 3)}</td>
																<td>{item.Code}</td>
																<td>{item.hasOwnProperty('Name') ? item.Name : item.Title}</td>
																<td>
																	{!hideCancelButton || item.EventId !== '54' ? <Popconfirm title={this.cancelText(item)}
																		okText="Yes" cancelText="No" onConfirm={() => { this.removeProgram(item) }}>
																		<Button type="danger" disabled={hideCancelButton}>Cancel</Button>
																	</Popconfirm> : ''}

																</td>
															</tr>
														)
													}

												})}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/Registered/index.jsx